import { ExportRequestStatusEnum } from "../enums/export-request-status.enum";

export const EXPORT_STATUS_COLORS: {
  [key in ExportRequestStatusEnum]: string;
} = {
  [ExportRequestStatusEnum.PENDING]: "orange",
  [ExportRequestStatusEnum.FINISHED]: "green",
  [ExportRequestStatusEnum.FAILED]: "red",
};
